import { getLanguageDisplayName } from 'util/formatUtil';
import { SUPPORTED_LANGUAGES } from 'constants/llmTranslation';

/**
 * Get the language display name for a given language code.
 * It uses the translation.SUPPORTED_LANGUAGES map.
 * If the language isn't supported, it uses the Web API as fallback.
 *
 * @param {string} languageCode
 * @return {string} - display name of language or 'Unknown'
 *
 * @example getLanguageName('en') // < 'English'
 */
export function getLanguageName(languageCode) {
  let nameFound = SUPPORTED_LANGUAGES[languageCode];

  if (nameFound) {
    return nameFound;
  }

  try {
    nameFound = getLanguageDisplayName(languageCode);
  } catch (err) {
    nameFound = 'Unknown';
  }

  // TODO: log that we got an language code not specified in SUPPORTED_LANGUAGES

  return nameFound;
}
